import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { KioskStateEnum } from './kiosk-state.enum';
import { Router } from '@angular/router';
import { LoggerService } from '../../../services/logger/logger.service';
import { BookingOrderService } from '../../booking/services/booking-order.service';
import { PartnerStateService } from '../../partner/services/partner-state.service';
import { Partner } from '../../partner/models/partner';
import { LoadingSpinnerService } from '../../../services/loading-spinner.service';
import { LoginStateService } from '../../login/services/login-state.service';
import { environment } from 'src/environments/environment';
import { PartnerService } from '../../partner/services/partner.service';


@Injectable()
export class KioskStateService {
  _state: KioskStateEnum = KioskStateEnum.Reset;

  _guestOfHonor: Partner;

  constructor(
    private router: Router,
    private logger: LoggerService,
    private bookingOrderService: BookingOrderService,
    private partnerStateService: PartnerStateService,
    private partnerService: PartnerService,
    private loginStateService: LoginStateService,
    private loadingSpinnerService: LoadingSpinnerService,
  ) {
  }

  get state(): KioskStateEnum {
    return this._state;
  }

  reinitialize(): Observable<boolean> {
    return Observable.create(
      (observable: Subscriber<boolean>) => {

        this.logger.info('KioskStateService: kioskReinitialize.');
        this._internalInitialize();
        observable.next(true);
        // this.bookingOrderService.kioskReinitialize().subscribe(
        //   done => {
        //     this.logger.info('KioskStateService: bookingOrderService kioskReinitializelize - initialize done.');
        //     observable.next(done);
        //   },
        //   error => {
        //     this.logger.info(`KioskStateService: bookingOrderService kioskReinitialize - initialize error ${error}.`);
        //     observable.error(error);
        //   },
        //   () => {
        //     // observable.complete();
        //   }
        // );
      });
  }

  private _internalInitialize(): void {
    this._state = KioskStateEnum.Reset;
    this.reset();
  }

  initialize(): Observable<boolean> {
    return Observable.create(
      (observable: Subscriber<boolean>) => {
        this.logger.info('KioskStateService: kioskInitialize.');
        this._internalInitialize();
        observable.next(true);
        // this.bookingOrderService.kioskInitialize().subscribe(
        //   done => {
        //     this.logger.info('KioskStateService: bookingOrderService kioskInitialize - initialize done.');
        //     observable.next(done);
        //   },
        //   error => {
        //     this.logger.info(`KioskStateService: bookingOrderService kioskInitialize - initialize error ${error}.`);
        //     observable.error(error);
        //   },
        //   () => {
        //     // observable.complete();
        //   }
        // );
      }
    );
  }

  update(
    state: KioskStateEnum = KioskStateEnum.Reset,
    child?: Partner
  ): void {

    this._state = state;

    switch (this._state) {
      case KioskStateEnum.ChildManagement:
        this._showChildManagementComponent();
        break;
      case KioskStateEnum.AddChild:
        this._showKioskAddChildComponent();
        break;
      case KioskStateEnum.EditChild:
        this._showKioskEditChildComponent(child);
        break;
      case KioskStateEnum.ThankYou:
        this._showKioskThankYouComponent();
        break;
      case KioskStateEnum.Birthday:
        this._showBirthdayComponent();
        break;
      case KioskStateEnum.SelectBookingEventProducts:
        this._showSelectBookingEventProductsComponent();
        break;
      case KioskStateEnum.SelectBookingExtraProducts:
        this._showSelectBookingAdvancedProductsComponent();
        break;
      case KioskStateEnum.LoginOrRegister:
        this._showLoginOrRegisterComponent();
        break;
      case KioskStateEnum.RegisterWithOrder:
        this._showRegisterWithOrderComponent();
        break;
      case KioskStateEnum.CreateOrder:
        this._createOrder();
        break;
      case KioskStateEnum.OrderComplete:
        this._showKioskOrderCompleteComponent();
        break;
      case KioskStateEnum.Reset:
        this.reset();
        this._showMainComponent();
        break;
      default:
        this.initialize().subscribe();
        break;
    }
  }

  private _showMainComponent(): void {
    this.router.navigate(['kiosk']);
  }

  private _showChildManagementComponent(): void {
    this.partnerStateService.updateSelectedChild(null);
    this.router.navigate(['kiosk/registration/childmanagement']);
  }

  private _showBirthdayComponent(): void {
    this.router.navigate(['kiosk/birthday']);
  }

  private _showSelectBookingEventProductsComponent(): void {
    this.router.navigate(['kiosk/event-products']);
  }

  private _showSelectBookingAdvancedProductsComponent(): void {
    this.router.navigate(['kiosk/advanced-product']);
  }

  private _showLoginOrRegisterComponent(): void {
    this.router.navigate(['kiosk/login']);
  }

  private _showRegisterWithOrderComponent(): void {
    this.router.navigate(['kiosk/order-register']);
  }

  private _showKioskAddChildComponent(): void {
    this.router.navigate(['kiosk/registration/childmanagement/new']);
  }

  private _showKioskEditChildComponent(child: Partner): void {
    this.partnerStateService.updateSelectedChild(child);
    this.router.navigate(['kiosk/registration/childmanagement/edit']);
  }

  private _showKioskOrderCompleteComponent(): void {
    this.router.navigate(['kiosk/order-complete']);
  }

  private _showKioskThankYouComponent(): void {
    this.router.navigate(['kiosk/registration/thank_you']);
  }

  get isBookingSlotsAvailable(): boolean {
    switch (this.state) {
      case KioskStateEnum.Reset:
        return false;
    }
    return true;
  }

  get isBookingEventProductsAvailable(): boolean {
    switch (this.state) {
      case KioskStateEnum.Reset:
      case KioskStateEnum.Birthday:
        return false;
    }

    return this.bookingOrderService.isEventOrder;
  }

  get isBookingAdvancedProductsAvailable(): boolean {
    switch (this.state) {
      case KioskStateEnum.Reset:
      case KioskStateEnum.Birthday:
      case KioskStateEnum.SelectBookingEventProducts:
        return false;
    }

    return this.bookingOrderService.isAdditionalProductsExist;
  }

  get isBookingRegistrationAvailable(): boolean {
    switch (this.state) {
      case KioskStateEnum.Reset:
      case KioskStateEnum.Birthday:
      case KioskStateEnum.SelectBookingEventProducts:
      case KioskStateEnum.SelectBookingExtraProducts:
        return false;
    }

    return true;
  }

  get isBookingOrderAvailable(): boolean {
    switch (this.state) {
      case KioskStateEnum.Reset:
      case KioskStateEnum.Birthday:
      case KioskStateEnum.SelectBookingEventProducts:
      case KioskStateEnum.SelectBookingExtraProducts:
        return false;
    }

    return true;
  }

  get isBookingOrderComplete(): boolean {
    switch (this.state) {
      case KioskStateEnum.Reset:
      case KioskStateEnum.Birthday:
      case KioskStateEnum.SelectBookingEventProducts:
      case KioskStateEnum.SelectBookingExtraProducts:
      case KioskStateEnum.LoginOrRegister:
      case KioskStateEnum.RegisterWithOrder:
        return false;
    }

    return this._guestOfHonor != null && this.bookingOrderService.order != null;
  }

  _createOrder(): void {
    this.loadingSpinnerService.show();
    if (this.isBookingOrderAvailable) {
      if (this.bookingOrderService.eventCache) {
        this._guestOfHonor = this.bookingOrderService.eventCache.guestOfHonor;
      }
      this.bookingOrderService.createOrder().subscribe(
        order => {
          this.bookingOrderService.saleToInvoice(order.id).subscribe(
            result => {
              this.loadingSpinnerService.hide();
              this.update(KioskStateEnum.OrderComplete);
            });
        },
        error => {
          this.logger.info(error);
        }
      );
    }
  }

  get guestOfHonor(): Partner {
    return this._guestOfHonor;
  }

  reset(): void {
    if (this.loginStateService.isLoggedIn) {
      this.loginStateService.logout().subscribe();
    }
    this._guestOfHonor = null;
  }

  get isKioskMode(): boolean {
    if (environment.shopMode && ['kiosk', 'webshop&kiosk'].indexOf(environment.shopMode) !== -1) {
      return true;
    }
    return false;
  }
}
